import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { FilePlus2, LayoutGrid, BookOpen, ArrowRight, FileStack } from 'lucide-react'
import { lessonApi } from '../../features/lesson-builder/api/lessonBuilderApi'
import { countCards } from '../../features/lesson-builder/lib/sections'
import type { LessonDoc } from '../../features/lesson-builder/types/LessonDoc'

// Quản lý nội dung (MỚI): điều hướng tới Studio e-learning + danh sách bài giảng gần đây.
// Thay cho TestTeacherContent (cũ).
const TeacherContentPanel: React.FC = () => {
  const [lessons, setLessons] = useState<LessonDoc[] | null>(null)

  useEffect(() => {
    lessonApi.list().then((l) => setLessons(l)).catch(() => setLessons([]))
  }, [])

  const actions = [
    { to: '/soan-bai', icon: FilePlus2, title: 'Soạn bài giảng mới', desc: 'Tạo bài e-learning: thẻ, mô phỏng, trắc nghiệm…', color: 'bg-blue-600' },
    { to: '/teacher/elearning', icon: LayoutGrid, title: 'Bài giảng của tôi', desc: 'Quản lý & xuất bản bài giảng', color: 'bg-emerald-600' },
    { to: '/teacher/khoa-hoc', icon: BookOpen, title: 'Khoá học của tôi', desc: 'Gom bài giảng thành khoá học', color: 'bg-violet-600' },
  ]

  return (
    <div className="mt-6 space-y-6">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {actions.map((a) => {
          const Icon = a.icon
          return (
            <Link key={a.to} to={a.to} className="group bg-white border border-gray-200 rounded-2xl p-5 hover:shadow-md hover:border-blue-200 transition-all">
              <span className={`w-11 h-11 rounded-xl ${a.color} text-white flex items-center justify-center mb-3`}><Icon size={22} /></span>
              <h3 className="font-bold text-gray-900">{a.title}</h3>
              <p className="text-sm text-gray-500 mt-0.5">{a.desc}</p>
              <span className="mt-2 inline-flex items-center gap-1 text-sm font-semibold text-blue-600 group-hover:gap-2 transition-all">Mở <ArrowRight size={14} /></span>
            </Link>
          )
        })}
      </div>

      <div className="bg-white border border-gray-200 rounded-2xl p-5">
        <div className="flex items-center justify-between mb-3">
          <h3 className="font-black text-gray-800">Bài giảng gần đây</h3>
          <Link to="/teacher/elearning" className="text-sm font-semibold text-blue-600 hover:underline">Xem tất cả</Link>
        </div>
        {lessons === null ? (
          <p className="text-sm text-gray-400 py-6 text-center">Đang tải…</p>
        ) : lessons.length === 0 ? (
          <div className="text-center py-10 text-gray-300">
            <FileStack size={40} className="mx-auto mb-2" />
            <p className="text-gray-400 font-medium">Chưa có bài giảng nào. Bấm “Soạn bài giảng mới” để bắt đầu.</p>
          </div>
        ) : (
          <div className="divide-y divide-gray-100">
            {lessons.slice(0, 8).map((l) => (
              <div key={l.id} className="flex items-center justify-between py-2.5">
                <div className="min-w-0">
                  <p className="font-semibold text-gray-800 truncate">{l.meta?.tieuDe || 'Chưa đặt tên'}</p>
                  <p className="text-xs text-gray-400">
                    {countCards(l)} thẻ · {l.status === 'published' ? 'Đã xuất bản' : 'Nháp'}
                  </p>
                </div>
                <div className="flex gap-3 shrink-0">
                  <Link to={`/soan-bai/${l.id}`} className="text-sm font-semibold text-gray-600 hover:text-blue-600">Sửa</Link>
                  {l.slug && <Link to={`/bai-giang/${l.slug}`} className="text-sm font-semibold text-emerald-600 hover:text-emerald-700">Xem</Link>}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default TeacherContentPanel
